    import React from "react";
    import { Dialog } from 'primereact/dialog';
    import useTranslations from "i18n/useTranslations";
    function ModalVerified({
        open = false,
        onClose = () => console.log('onClose'),
        onClick = () => console.log('onClick'),
        isButtonDisabled = false
    }) {
        const { t } = useTranslations();
        return (
            <Dialog visible={open} style={{ width: '325px' }} onHide={() => onClose()} draggable={false} resizable={false} closable={false}>
                <div className="bModal bCard" id="ModalAlert">
                    <div className="bInner" style={{ width: "100%"}}>
                        <div className="bDetails">
                            <h3>{t.register.popup.registerComplete}</h3>
                            <p>
                                {t.register.popup.registerCompleteBody}
                            </p>
                        </div>
                        <div className="bBtn" style={{ display: 'flex', flexDirection: "column", gap: "16px" }}>
                            <button onClick={onClick} className="btn btnCloseModal" disabled={isButtonDisabled}>{t.register.popup.close}</button>
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }

    export default ModalVerified;
